import React from "react";
import Popup from "../../common/popup";
export default class ProfilePopup extends React.Component {
    render(){
        return (
          <Popup style={{ height: 250, width: "38%" }} closePopup={this.closePopup}>
            <div style={{ padding: "10px 25px" }}>
              <p>
                <b>Alert</b>
              </p>
                <div>
                  <p style={{paddingTop:8}}>We have sent the activation Email, please activate to unlock your free credits.</p> 
                  <p style={{opacity:0.7, paddingTop:17}}><b>Note:</b> Check your Junk or Spam folders if you don't see it in the Inbox.</p>                   
                    <div className="popup-btn">
                      <button
                        className="btn btn-outline-primary"
                        style={{ marginRight: 10 }}
                        onClick={this.props.onOKClick}
                      >
                        May be Later
                      </button>
                      <button
                        className="btn btn-primary"
                        style={{ marginRight: 10 }}
                        onClick={this.props.onResendActivation}
                      >
                        Resend Activation E-mail
                      </button>
                    </div>
                </div>
            </div>
          </Popup>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Login/companyProfilePopup.js